function stdevAndMean(values) {
  // returns an array of stdev
  var i,
    j,
    total = 0,
    mean = 0,
    diffSqredArr = [];
  for (i = 0; i < values.length; i += 1) {
    total += values[i];
  }
  mean = total / values.length;
  for (j = 0; j < values.length; j += 1) {
    diffSqredArr.push(Math.pow(values[j] - mean, 2));
  }
  const stdev = Math.sqrt(
    diffSqredArr.reduce(function (firstEl, nextEl) {
      return firstEl + nextEl;
    }, 0) / values.length,
  );

  return { mean, stdev };
}

export { stdevAndMean };
